import React, { Component } from "react";
import * as s from "./HierarchicalDropdown.module.scss";
import { Icons } from "src/libs/assets";
import { P, Checkbox, Progressbar } from "src/views/shared/components";
import { observer } from "mobx-react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  dropdownTitle: string;
  options?: any;
  toggleOption: any;
}

interface State {
  open: boolean;
}

@observer
export class HierarchicalDropdown extends Component<Props, State> {
  state = {
    open: false
  };

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  };

  renderOption = (item, key, array, parent = null) => {
    const { options, toggleOption } = this.props;
    const { value, contributionPercentage, numberOfDocuments, selected, children } = item;

    let dropdownItemClasses = [s.dropdownItemContainer];

    let formattedValue = value; //numberOfDocuments ? value + ` (${numberOfDocuments})` : value;

    let childToRender = children;
    if (selected && children && children.length > 0) {
      if (options && children.some(option => option.selected)) {
        childToRender = children.filter(option => option.selected === true);
      }
    }

    return (
      <div className={dropdownItemClasses.join(" ")} key={key}>
        <div className={s.dropdownRootItem}>
          <Checkbox
            type="check"
            onChange={() => toggleOption(options, item, parent)}
            selected={selected}
            className={s.dropdownCheckbox}
          >
            <div className={s.dropdownRootItemLabelContainer}>
              <P className={s.dropdownRootItemLabel}>{formattedValue}</P>
              {contributionPercentage > 0 && (
                <Progressbar percent={contributionPercentage} />
              )}
            </div>
          </Checkbox>
        </div>

        {selected && children && children.length > 0 && (
          <div className={s.dropdownChildItemsContainer}>
            {childToRender &&
              childToRender.map((childItem, key) =>
                this.renderOption(childItem, key, null, item)
              )}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { className, dropdownTitle, options } = this.props;
    const { open } = this.state;

    const filterDropdownClasses = [s.filterDropdown];
    const dropdownItemsClasses = [s.dropdownItems];
    let icon = Icons.chevronDown_large;
    const hasSelected = options.find(opt => opt.selected);

    if (className) {
      filterDropdownClasses.push(className);
    }

    if (open || hasSelected) {
      filterDropdownClasses.push(s.open);
      icon = Icons.chevronUp_large;
    }

    let optionsToRender = options;

    if (options && options.some(option => option.selected)) {
      optionsToRender = options.filter(option => option.selected === true);
    }

    return (
      <div className={filterDropdownClasses.join(" ")}>
        <div className={s.dropdownHeader} onClick={this.toggleOpen}>
          <h6 className={s.dropdownTitle}>{dropdownTitle}</h6>
          <img src={icon} className={s.chevronDown} alt="Arrow down" />
        </div>
        <div className={dropdownItemsClasses.join(" ")}>
          {optionsToRender && optionsToRender.map(this.renderOption)}
        </div>
      </div>
    );
  }
}
